/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdDatePickerPanelProps } from '../date-picker/type';
import { PropType } from 'vue';

export default {
  /** 点击日期单元格时触发 */
  onCellClick: Function as PropType<TdDatePickerPanelProps['onCellClick']>,
  /** 选中值发生变化时触发。参数 `context.trigger` 表示触发当前事件的来源，不同的模式触发来源也会不同 */
  onChange: Function as PropType<TdDatePickerPanelProps['onChange']>,
  /** 如果存在“确认”按钮，则点击“确认”按钮时触发 */
  onConfirm: Function as PropType<TdDatePickerPanelProps['onConfirm']>,
  /** 月份切换发生变化时触发 */
  onMonthChange: Function as PropType<TdDatePickerPanelProps['onMonthChange']>,
  /** 点击面板时触发 */
  onPanelClick: Function as PropType<TdDatePickerPanelProps['onPanelClick']>,
  /** 如果存在“确认”按钮，则点击“确认”按钮时触发 */
  onPresetClick: Function as PropType<TdDatePickerPanelProps['onPresetClick']>,
  /** 时间切换发生变化时触发 */
  onTimeChange: Function as PropType<TdDatePickerPanelProps['onTimeChange']>,
  /** 年份切换发生变化时触发 */
  onYearChange: Function as PropType<TdDatePickerPanelProps['onYearChange']>,
};
